import React, { useState } from "react";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { createTeam } from "services/teams_service";
import Select from "react-select";

import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import config from "config.json";

function App({ refresh }) {
  const navigate = useNavigate();

  const { register, handleSubmit } = useForm({});
  const [ division, setDivision ] = useState(null);

  const submitForm = async (data) => {
    try {
      await createTeam({...data, division, accounts: [localStorage.getItem("accountId")]});
      navigate("/equipas");
    } catch (exception) {
      console.log(
        "Unexpected error, it was not possible to create a team",
        exception
      );
    }
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li className="is-active">Equipas</li>
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Equipas</h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="column is-two-thirds">
              <form onSubmit={handleSubmit((data) => submitForm(data))}>
                <div className="block">
                  <div className="field">
                    <label className="label">Nome da equipa:</label>
                    <p className="control">
                      <input
                        className="input"
                        type="text"
                        {...register("name", {
                          required: true,
                          minLength: 5,
                        })}
                        placeholder="Nome da Equipa"
                      />
                    </p>
                  </div>
                </div>

                <div className="block">
                  <div className="field">
                    <label className="label">Escalão:</label>
                    <div className="select is-info">
                      <select
                        {...register("level", {
                          required: true,
                        })}
                      >
                        <option value={null}></option>
                        {config.COMPETITIONS_LEVEL_NO_MULTIPLE.map((el, idx) => (
                          <option key={idx} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="block">
                  <div className="field">
                    <label className="label">Divisão:</label>
                    <div className="select is-info">
                    <Select
                        onChange={(evt) => {
                          setDivision(evt.value);
                        }}
                        options={config.DIVISIONS_OPTIONS}
                      />
                    </div>
                  </div>
                </div>

                <button className="button is-link is-footsolution">Guardar</button>
              </form>
            </div>
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
